(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/snake.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/snake.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useRef,
  useState
} = React;
const Snake = _ref => {
  let {
    classNames
  } = _ref;
  const canvasRef = useRef(null);
  const [running, setRunning] = useState(true);
  const [score, setScore] = useState(0);
  const dirRef = useRef({
    x: 1,
    y: 0
  });
  const snakeRef = useRef([{
    x: 10,
    y: 10
  }]);
  const appleRef = useRef({
    x: 15,
    y: 10
  });
  const speedRef = useRef(120);
  const TILE_COUNT = 20;
  const placeApple = () => {
    const snake = snakeRef.current;
    for (let attempts = 0; attempts < 1000; attempts += 1) {
      const pos = {
        x: Math.floor(Math.random() * TILE_COUNT),
        y: Math.floor(Math.random() * TILE_COUNT)
      };
      if (!snake.some(s => s.x === pos.x && s.y === pos.y)) {
        appleRef.current = pos;
        return;
      }
    }
    appleRef.current = {
      x: 0,
      y: 0
    };
  };
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const draw = () => {
      ctx.fillStyle = '#0b0b0b';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#e74c3c';
      ctx.fillRect(appleRef.current.x * (canvas.width / TILE_COUNT), appleRef.current.y * (canvas.height / TILE_COUNT), canvas.width / TILE_COUNT, canvas.height / TILE_COUNT);
      ctx.fillStyle = '#2ecc71';
      snakeRef.current.forEach(s => {
        ctx.fillRect(s.x * (canvas.width / TILE_COUNT), s.y * (canvas.height / TILE_COUNT), canvas.width / TILE_COUNT, canvas.height / TILE_COUNT);
      });
    };
    const step = () => {
      if (!running) {
        return;
      }
      const head = _objectSpread({}, snakeRef.current[0]);
      head.x += dirRef.current.x;
      head.y += dirRef.current.y;
      head.x = (head.x + TILE_COUNT) % TILE_COUNT;
      head.y = (head.y + TILE_COUNT) % TILE_COUNT;
      if (snakeRef.current.some(part => part.x === head.x && part.y === head.y)) {
        setRunning(false);
        return;
      }
      snakeRef.current.unshift(head);
      if (head.x === appleRef.current.x && head.y === appleRef.current.y) {
        setScore(s => s + 1);
        speedRef.current = Math.max(40, speedRef.current - 3);
        placeApple();
      } else {
        snakeRef.current.pop();
      }
      draw();
    };
    let raf = null;
    let last = 0;
    const loop = time => {
      if (!last) {
        last = time;
      }
      const delta = time - last;
      if (delta > speedRef.current) {
        step();
        last = time;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [running]);
  useEffect(() => {
    const onKey = e => {
      const k = e.key;
      const dir = dirRef.current;
      if (k === 'ArrowUp' && dir.y !== 1) {
        dirRef.current = {
          x: 0,
          y: -1
        };
      }
      if (k === 'ArrowDown' && dir.y !== -1) {
        dirRef.current = {
          x: 0,
          y: 1
        };
      }
      if (k === 'ArrowLeft' && dir.x !== 1) {
        dirRef.current = {
          x: -1,
          y: 0
        };
      }
      if (k === 'ArrowRight' && dir.x !== -1) {
        dirRef.current = {
          x: 1,
          y: 0
        };
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  const restart = () => {
    snakeRef.current = [{
      x: 10,
      y: 10
    }];
    dirRef.current = {
      x: 1,
      y: 0
    };
    speedRef.current = 120;
    setScore(0);
    placeApple();
    setRunning(true);
  };
  const canvasStyle = {
    width: '100%',
    height: 300,
    background: '#0b0b0b',
    display: 'block'
  };
  return React.createElement("div", {
    className: "".concat(classNames, " show-game competition-snake")
  }, React.createElement("div", {
    className: "competition-snake-header"
  }, React.createElement("div", {
    className: "competition-snake-score"
  }, "Po\xE4ng: ".concat(score)), !running && React.createElement("button", {
    className: "button-200 qa-competition-snake-restart",
    onClick: restart,
    type: "button"
  }, "Starta om")), React.createElement("canvas", {
    height: TILE_COUNT * 12,
    ref: canvasRef,
    style: canvasStyle,
    width: TILE_COUNT * 12
  }));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.Snake', Snake);

 })(window);